import { Decimal } from 'decimal.js';

import { marketLabel } from '../lib/protocol';
import { matchTitle } from './matchTitle';
import type { Meta } from './meta';
import type { FeedRow } from './rows';
import { moneyAmount, profitText, type ShowUnit } from './show';

export interface ReviewLeg {
  book: string;
  code: string;
  side: string;
  odds: string;
  stake: string;
}

/** То, что уходит в отзыв. Ссылок на конторы здесь нет. */
export interface ReviewCard {
  forkId: string;
  match: string;
  sport: string;
  market: string;
  roi: string;
  gain: string;
  legs: [ReviewLeg, ReviewLeg];
}

function oddsOf(raw: string): string | null {
  try {
    const odds = new Decimal(raw);
    if (!odds.isFinite() || odds.lte(1)) return null;
    return odds.toFixed(3);
  } catch {
    return null;
  }
}

export function reviewCard(row: FeedRow, meta: Meta, fx: number, unit: ShowUnit): ReviewCard | null {
  const legs = row.row.legs.slice(0, 2);
  if (legs.length < 2) return null;
  const pair = legs.map((leg): ReviewLeg | null => {
    const odds = oddsOf(leg.odds);
    const side = leg.side.trim();
    const book = (meta.venues[leg.source]?.name || leg.source).trim();
    if (!odds || !side || !book) return null;
    const stake = typeof leg.rub === 'number' ? moneyAmount(leg, fx, meta) : '';
    return { book, code: leg.source, side, odds, stake };
  });
  const left = pair[0];
  const right = pair[1];
  if (left == null || right == null) return null;
  let roi = '';
  try {
    const value = new Decimal(row.row.fork.roi ?? '');
    if (value.isFinite()) roi = value.toFixed(2);
  } catch {
    /* процент не обязателен: в журнал кладём и минус, и пустую клетку */
  }
  const profit = row.row.profit;
  const gain =
    typeof profit === 'number' && Number.isFinite(profit)
      ? profitText(profit, Number(roi), fx, unit === 'pct' ? 'rub' : unit)
      : '';
  const code = row.row.fork.sport ?? '';
  const said = marketLabel(row.row.fork.market, code);
  return {
    forkId: row.id,
    match: matchTitle(row),
    sport: meta.sportNames[code] || row.row.fork.sportName || code || 'матч',
    market: said.includes(':') || said === '—' ? '' : said,
    roi,
    gain,
    legs: [left, right],
  };
}
